/* eslint-disable react/no-array-index-key */
/* eslint-disable react/function-component-definition */
import React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import Plaatjie from '@ubo/plaatjie'

import 'slick-carousel/slick/slick.css'

const Section = styled.section`
  @media (min-width: 992px) {
    padding-top: 119px;
    padding-bottom: 120px;
  }

  @media (max-width: 991.98px) {
    padding-block: 2rem;
  }
`

const Title = styled.h2`
  color: ${(props) => props.theme.color.text.main};
  font-weight: 600;
  text-align: center;

  @media (min-width: 992px) {
    font-size: 50px;
    line-height: 50px;
    margin-bottom: 40px;
  }

  @media (max-width: 991.98px) {
    font-size: 32px;
    margin-bottom: 2rem;
  }
`

const Arrow = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: #d50021;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  &:focus {
    outline: none;
  }

  /* .slick-slider is position: relative, so offsets are relative to the
     slide area — pull the arrows out into the wrapper's gutter. */
  @media (min-width: 992px) {
    width: 40px;
    height: 40px;

    ${(props) => (props.direction === 'prev' ? `left: -48px;` : `right: -48px;`)}
  }

  @media (max-width: 991.98px) {
    width: 32px;
    height: 32px;

    ${(props) => (props.direction === 'prev' ? `left: -32px;` : `right: -32px;`)}
  }
`

const SliderWrapper = styled.div`
  position: relative;

  @media (min-width: 992px) {
    padding-inline: 56px;
  }

  @media (max-width: 991.98px) {
    width: 100vw;
    margin-left: calc(50% - 50vw);
    padding-inline: 32px;
  }

  .slick-list {
    width: 100%;
  }

  .slick-track {
    display: flex;
    align-items: center;
  }

  .slick-slide {
    height: auto;
  }

  .slick-slide > div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  & .gatsby-image-wrapper,
  & picture,
  & img,
  & svg {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  }

  & img {
    object-fit: contain !important;
    object-position: center;
  }

  & svg {
    object-fit: contain;
  }

  @media (min-width: 992px) {
    height: 80px;
    padding-inline: 1.75rem;
  }

  @media (max-width: 991.98px) {
    height: 72px;
    padding-inline: 0.5rem;
  }
`

const Chevron = ({ direction }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    aria-hidden="true"
    focusable="false"
    style={direction === 'prev' ? { transform: 'rotate(180deg)' } : undefined}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 14L8 7L1.66948e-07 4.76837e-07L0 14Z"
      fill="#D50021"
    />
  </svg>
)

const PrevArrow = ({ onClick }) => (
  <Arrow type="button" direction="prev" aria-label="Vorige" onClick={onClick}>
    <Chevron direction="prev" />
  </Arrow>
)

const NextArrow = ({ onClick }) => (
  <Arrow type="button" direction="next" aria-label="Volgende" onClick={onClick}>
    <Chevron direction="next" />
  </Arrow>
)

function Partners({ title, images }) {
  if (!images || images.length === 0) {
    return null
  }

  return (
    <Section>
      <div className="container">
        {title && <Title>{title}</Title>}

        <SliderWrapper>
          <Slider
            dots={false}
            arrows
            infinite
            prevArrow={<PrevArrow />}
            nextArrow={<NextArrow />}
            slidesToShow={images.length > 5 ? 5 : images.length}
            slidesToScroll={1}
            autoplay
            autoplaySpeed={3000}
            speed={1000}
            responsive={[
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: images.length > 3 ? 3 : images.length,
                },
              },
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: images.length > 2 ? 2 : images.length,
                },
              },
            ]}
          >
            {images.map((image, index) => (
              <div key={index}>
                <Logo>
                  <Plaatjie image={image} alt="" />
                </Logo>
              </div>
            ))}
          </Slider>
        </SliderWrapper>
      </div>
    </Section>
  )
}

export default Partners
